import { useState } from "react";

export interface IStep {
    label: string;
    id: number;
}

interface IUseStepsProps {
    steps: IStep[];
    initialStep?: number;
    infinity?: boolean;
}

const useSteps = ({ steps, initialStep = 0, infinity }: IUseStepsProps) => {
    const [activeStepIndex, setActiveStepIndex] = useState(initialStep);

    const handlePreviousStep = () => {
        if (activeStepIndex === 0 && !infinity) return;
        if (activeStepIndex === 0 && infinity) {
            setActiveStepIndex(steps.length - 1);
            return;
        }
        setActiveStepIndex(activeStepIndex - 1);
    };

    const handleNextStep = () => {
        if (activeStepIndex === steps.length - 1 && !infinity) return;
        if (activeStepIndex === steps.length - 1 && infinity) {
            setActiveStepIndex(0);
            return;
        }
        setActiveStepIndex(activeStepIndex + 1);
    };

    const setStepManually = (step: number) => {
        setActiveStepIndex(step);
    };

    return { activeStep: steps[activeStepIndex], handlePreviousStep, handleNextStep, setStepManually };
};

export default useSteps;
